import { Event } from "@app/core/tracking/domain/event";

/**
 * Event fired when the user views the usual purchase page.
 */
export class UsualPurchaseViewedEvent extends Event {
}